import { User } from '@bonusly/common-action-input';

import { FeedbackApiData } from '../types/feedback';

export const gatherUserIds = (evaluations: FeedbackApiData[]) => {
	const userIds = new Array<string>();

	evaluations.forEach((evaluation) => {
		userIds.push(evaluation.receiver_id);
		if (evaluation.giver_id) userIds.push(evaluation.giver_id);
	});

	return [...new Set(userIds)];
};

export const mapToUsers = (data: any): User[] => {
	return data.data.result.map(
		(data: any) =>
			new User({
				id: data.id,
				username: data.username,
				displayName: data.display_name,
				profilePic: data.profile_pic_url,
			})
	);
};
